module.exports = __webpack_public_path__ + "media/barcelona_muted_compressed.14816fe3.mp4";